import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Header.tsx");
